import { render, staticRenderFns } from "./HelpCenterView.vue?vue&type=template&id=527f39f4&scoped=true"
import script from "./HelpCenterView.vue?vue&type=script&lang=ts"
export * from "./HelpCenterView.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterView.vue?vue&type=style&index=0&id=527f39f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f39f4",
  null
  
)

export default component.exports